/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DomainDynamicInputDto } from './DomainDynamicInputDto';
import type { TeamPermissionAssignmentDto } from './TeamPermissionAssignmentDto';
import type { UserPermissionAssignmentDto } from './UserPermissionAssignmentDto';

export type CreateDomainRequestDto = {
    assets: Array<string>;
    description?: string;
    domainInputMethod: CreateDomainRequestDto.domainInputMethod;
    dynamicInput?: DomainDynamicInputDto;
    name: string;
    parentDomainId?: string;
    teams: Array<TeamPermissionAssignmentDto>;
    users: Array<UserPermissionAssignmentDto>;
};

export namespace CreateDomainRequestDto {

    export enum domainInputMethod {
        STATIC = 'STATIC',
        DYNAMIC = 'DYNAMIC',
    }


}
